import { gql } from './gql'

/**
 * Category fields
 * @internal
 */
export const categoriesFieldsQuery: string = `
  id
  name
  isActive
  priority
  imageURL
  parentId
`

/**
 * The storefront's categories, as the storefront authored them.
 *
 * Until now the chips were derived from whatever the first catalog page came
 * back with, which makes the rail a view of one page rather than of the
 * storefront: a category whose products all sit on page two simply did not
 * exist. This is the same list cinnamon's category nav reads, and it carries
 * what an authored order needs — `priority`, `isActive`, and `parentId` so a
 * child category can be told from a top-level one.
 *
 * `sessionUid` is a `String` here, not the `ID!` the cart and session fields
 * take. That is the schema's own inconsistency, not a typo: sending `ID!` makes
 * the server reject the whole document.
 */
export const GET_CATEGORIES = gql`
  query GetCategories(
    $storefrontName: String!
    $sessionUid: String
    $pagination: PaginationInput
    $parentId: ID
    $showChildrenCategories: Boolean
  ) {
    categories(
      storefrontName: $storefrontName
      sessionUid: $sessionUid
      pagination: $pagination
      parentId: $parentId
      showChildrenCategories: $showChildrenCategories
    ) {
      ${categoriesFieldsQuery}
    }
  }
`
